/**
 * 图片灯箱组件
 * 用于大图查看
 */

import React from 'react';
import { X } from 'lucide-react';

interface LightboxProps {
  /** 当前显示的图片 URL */
  src: string | null;
  /** 图片标题 */
  title: string;
  /** 关闭回调 */
  onClose: () => void;
}

/**
 * 图片灯箱组件
 * 全屏显示单张图片，支持点击关闭
 */
export const Lightbox: React.FC<LightboxProps> = ({ src, title, onClose }) => {
  if (!src) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="relative max-w-[90vw] max-h-[90vh]" 
        onClick={e => e.stopPropagation()}
      >
        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-10 w-8 h-8 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center text-white shadow-lg transition-colors"
        >
          <X size={16} />
        </button>

        {/* 图片 */}
        <img
          src={src}
          alt={title}
          className="max-w-full max-h-[85vh] rounded-lg shadow-2xl object-contain"
        />

        {/* 标题 */}
        {title && (
          <div className="absolute bottom-0 left-0 right-0 px-3 py-2 bg-gradient-to-t from-black/80 to-transparent rounded-b-lg">
            <p className="text-[12px] text-white/90 truncate">{title}</p>
          </div>
        )}
      </div>
    </div>
  );
};
